export default "__VITE_ASSET__cz6uYKGq__"